import React from "react";
import { useTranslation } from "react-i18next";
import Text from "@/components/ui/text";
import { ProductBadge } from "@dreamhub/designsystem/icons";

const ProductEmptyState: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center h-100 rounded-lg">
      <ProductBadge />
      <div className="flex flex-col items-center justify-center">
        <Text variant="body" className="mb-2">
          {t("contractTerms.selectProductFirst")}
        </Text>
        <Text variant="bodySecondary" className="text-center text-sm">
          {t("contractTerms.selectProductDescription")}
        </Text>
      </div>
    </div>
  );
};

export default ProductEmptyState;
